
<mat-card>
  <mat-card-header>
    <mat-card-title>Manage Hub Documents</mat-card-title>
  </mat-card-header>
  <div class="documents-header-actions">
    <button mat-flat-button color="primary">Upload Document</button>
  </div>
  <mat-card-content>
    <div class="documents-container">
      <div class="documents-folders">
        <h3>Folders</h3>

        <mat-tree #tree [dataSource]="dataSource" [childrenAccessor]="childrenAccessor" class="document-tree">


          <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild"
                                matTreeNodeToggle [cdkTreeNodeTypeaheadLabel]="node.name"
                                (click)="getNodeFiles(node)"
                                (activation)="getNodeFiles(node)">
            <div class="mat-tree-node">
              <button matButton matTreeNodeToggle
                      [attr.aria-label]="'Toggle ' + node.name"
                      (click)="getNodeFiles(node)">
                <mat-icon class="mat-icon-rtl-mirror">
                  {{( tree.isExpanded(node) && node.subdirectories?.length > 0 ) ? 'folder_copy' : 'folder' }}
                </mat-icon>
                {{node.name}}
              </button>

            </div>

            <div [class.document-tree-invisible]="!tree.isExpanded(node)"
                 role="group">
              <ng-container matTreeNodeOutlet></ng-container>
            </div>
          </mat-nested-tree-node>



        </mat-tree>

      </div>

      <div class="documents-files">
        <h3>Files</h3>
        <h4>{{ selectedNode?.name }}</h4>
        <cdk-virtual-scroll-viewport [itemSize]="20" class="documents-files-container">

          <ng-container *cdkVirtualFor="let file of nodeFiles;">
            <mat-card class="documents-file">
              <mat-card-header>
                <mat-card-subtitle><mat-icon aria-hidden="false" aria-label="File icon">description</mat-icon> {{ file.displayName }}</mat-card-subtitle>
              </mat-card-header>
              <mat-card-content>
                <p>
                  <small>uploaded at: {{ file.addedDate | date: 'MMM dd, yyyy hh:mm a' }}</small>
                </p>
                <p>
                  <small>uploaded by: {{ file.recordCreatedUserName }}</small>
                </p>
              </mat-card-content>
              <mat-card-actions align="end">
                <button matButton>download</button>
                <button matButton>delete</button>
              </mat-card-actions>
            </mat-card>
          </ng-container>

        </cdk-virtual-scroll-viewport>


      </div>

    </div>

  </mat-card-content>
</mat-card>

